export const environment = {
  production: true,
  url: 'https://api.mallgo.co',
  billsServiceUrl: 'https://8jqz5x05pd.execute-api.us-east-2.amazonaws.com/process',
  recaptcha: {
    siteKey: '6Lc9bq0pAAAAAPFnHYDcktjY8QIAv4-uSxwvJlrV'
  },
};


export const SERVER_URL = 'https://api.demo.mallgo.co'